// המרת הקובץ למחרוזת Base64 עבור ה-API
const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.split(',')[1]);
  reader.onerror = error => reject(error);
});

// --- פונקציית סוכן AI ענן לזיהוי טקסט (Gemini 1.5 Flash REST API) ---
export const extractDataFromDocument = async (file, type) => {
  try {
    console.log('מתחיל סריקת מסמך חכמה בעזרת מודל Gemini...');
    
    const base64Data = await fileToBase64(file);
    const mimeType = file.type || 'image/jpeg';
    
    // משיכת המפתח: עדיפות למפתח ייעודי, אחרת שימוש במפתח הקיים של Vision.
    // אם אין מפתח בכלל, נשתמש במפתח חירום קבוע.
    const GOOGLE_GEMINI_API_KEY = process.env.REACT_APP_GOOGLE_GEMINI_API_KEY || process.env.REACT_APP_GOOGLE_VISION_API_KEY || "AIzaSyAF54YAMi6ifCcfW2fknswJs6cE7VypzM0";

    let prompt = "";
    if (type === 'client') {
      prompt = `
        You are an expert OCR, data extraction, and spatial understanding system for Israeli identity documents.
        Extract the following:
        1. The person's exact 9-digit ID number (תעודת זהות).
        2. The full name (first and last name in Hebrew).
        3. The bounding box of the person's face/portrait photo on the card in the format [ymin, xmin, ymax, xmax] where values are integers from 0 to 1000. If no photo is found, return null.
        Return ONLY a raw JSON object with the exact keys "idNumber", "name", and "faceBoundingBox".
        Do NOT wrap the JSON in markdown formatting or backticks.
      `;
    } else if (type === 'case') {
      prompt = `
        You are an elite AI legal document analysis assistant.
        Analyze this Israeli legal court document (כתב בי דין).
        Extract the required fields precisely.
        Return ONLY a valid, raw JSON object. Do not wrap it in markdown block quotes (\`\`\`).
        Keys to return:
        - "id": The case number (e.g. ת.א 1234-05-22 or similar format).
        - "court": The name of the court (e.g. בית משפט השלום תל אביב).
        - "city": The city of the court (e.g. תל אביב).
        - "foundPlaintiff": The name of the plaintiff/applicant (התובע / המבקש).
        - "opposingParties": The name of the defendant/respondent (הנתבע / המשיב).
        - "type": The legal type of the case. Choose from: ["אזרחי", "פלילי", "משפחה", "דיני עבודה", "אחר"].
        If a field is not found, leave it as an empty string.
      `;
    }

    const requestBody = {
      contents: [{
        parts: [
          { text: prompt },
          { inlineData: { mimeType, data: base64Data } }
        ]
      }],
      generationConfig: {
        responseMimeType: "application/json"
      }
    };

    const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${GOOGLE_GEMINI_API_KEY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    });
    
    const result = await response.json();
    
    if (!response.ok) {
       console.error("Gemini API Error Response:", result);
       throw new Error(result.error?.message || 'Failed to generate content (API Error)');
    }
    
    const responseText = result.candidates[0].content.parts[0].text;
    console.log("Raw output from Gemini:\n", responseText);
    
    let parsedData = {};
    try {
      parsedData = JSON.parse(responseText);
    } catch (e) {
      console.warn("Failed to parse JSON natively, using fallback extraction", e);
      const jsonMatch = responseText.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        parsedData = JSON.parse(jsonMatch[0]);
      }
    }

    if (type === 'case' && parsedData.foundPlaintiff && parsedData.opposingParties) {
       parsedData.title = `${parsedData.foundPlaintiff} נ' ${parsedData.opposingParties}`;
    }

    parsedData.rawText = JSON.stringify(parsedData, null, 2);
    return parsedData;

  } catch (error) {
    console.error('Gemini OCR Error:', error);
    
    let userFriendlyError = error.message;
    if (error.message.includes("API key not valid") || error.message.includes("API Error")) {
      userFriendlyError = "מפתח ה-API של גוגל חסר, שגוי, או שאין לו הרשאה לשירותי Generative Language. אנא ודא שמפתח תקין מוזן ב-env.";
    }
    
    return { rawText: "שגיאת שרת בפענוח מסמך: " + userFriendlyError };
  }
};
